import { TYPE_COLOR, getImportanceDisplay, getImportanceColor, getStateDisplay, getStateColor } from './yourNotesHelpers';
import { useUserSetting } from '../../../contexts/UserSettingsContext';
import { emsToDisplay } from '../../../services/utils/DateFormat';
import './YourNotesRow.css';

export default function YourNotesRow({ entry, selected, onClick, position, total }) {
    const subtopic = entry.service.split('.').slice(1).join('.');
    const importanceLabel = getImportanceDisplay(entry.importanceId);
    const importanceColor = getImportanceColor(entry.importanceId);
    const stateLabel = getStateDisplay(entry.stateId);
    const stateColor = getStateColor(entry.stateId);
    // ADDED — created/updated chips, same setting as ContentPanelMeta
    const chipDateTimeFormat = useUserSetting('contentPanel.chipDateTimeFormat');
    const createdDisplay = emsToDisplay(entry.ems, chipDateTimeFormat);
    const updatedDisplay = emsToDisplay(entry.updatedOn, chipDateTimeFormat);

    return (
        <div className={`fr-card${selected ? ' fr-card--selected' : ''}`} onClick={() => onClick(entry)}>
            <div className="fr-top">
                <span
                    className="fr-chip"
                    style={{ color: TYPE_COLOR[entry.type] || '#a3d1ff', borderColor: `${TYPE_COLOR[entry.type]}44` }}
                >
                    {entry.type}
                </span>
                <div className="fr-title">{entry.title}</div>
                {/* ADDED — position indicator, only on selected row */}
                {selected && position != null && (
                    <span className="fr-position">
                        {position} / {total}
                    </span>
                )}
            </div>
            <div className="fr-meta">
                {entry.stage && <span className="fr-badge">{entry.stage}</span>}
                {/* ADDED — state badge, only for non-active states */}
                {stateLabel && (
                    <span className="fr-badge" style={{ color: stateColor, borderColor: `${stateColor}44` }}>
                        {stateLabel}
                    </span>
                )}
                {importanceLabel && (
                    <span className="fr-badge" style={{ color: importanceColor, borderColor: `${importanceColor}44` }}>
                        {importanceLabel}
                    </span>
                )}
                {/* ADDED — created/updated chips */}
                {/* {entry.ems && (
                    <span className="fr-badge">Created: <span className="fr-badge-value">{createdDisplay}</span></span>
                )} */}
                {entry.updatedOn && (
                    <span className="fr-badge">
                        Updated: <span className="fr-badge-value">{updatedDisplay}</span>
                    </span>
                )}
                {subtopic && <span className="fr-topic">{subtopic}</span>}
            </div>
        </div>
    );
}
